import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import Select from 'react-select';
import {cloneDeep} from 'lodash';
import ReviewersTable from './ReviewersTable';
import ResultMessage from './ResultMessage';
import {commaDecimalToFloat, floatToCommaDecimal} from '../utils/number';
import {isNullOrUndefined} from '../utils/general';
import Utils from '../Utils';

export default class SeparateBidReviewsComponent extends Component {
    constructor(props) {
        super(props);

        const {assessorsDropdown} = window;

        this.state = {
            loading: false,
            result: null,
            reviewers: assessorsDropdown,
            selectedReviewers: [],
            selectedReviewersData: {},
            hasAwardingProposal: false,
            savingsAutomaticallyCalculated: false,
            data: {
                savings_amount: '',
                savings_percentage: '',
            },
        };

        this.awardingProposalInputRef = React.createRef();

        this.fetchData = this.fetchData.bind(this);
        this.onReviewersChange = this.onReviewersChange.bind(this);
        this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
        this.onPermissionChange = this.onPermissionChange.bind(this);
        this.saveReviewers = this.saveReviewers.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true}, () => {
            this
                .fetchData()
                .then((data) => {
                    const {
                        selectedReviewers,
                        selectedReviewersData,
                        hasAwardingProposal,
                        savingsAutomaticallyCalculated,
                        data: formData,
                    } = data;

                    this.setState({
                        loading: false,
                        selectedReviewers,
                        selectedReviewersData,
                        hasAwardingProposal,
                        savingsAutomaticallyCalculated,
                        data: formData,
                    });
                });
        });
    }

    fetchData() {
        const promises = [
            axios.get(`/competitions/assessors/${this.props.competitionId}`),
        ];

        return axios
            .all(promises)
            .then((responses) => {
                const data = responses[0].data;
                const existingReviewers = data.assessors;

                const selectedReviewers = [];
                const selectedReviewersData = {};

                existingReviewers.forEach((item) => {
                    selectedReviewers.push({
                        value: item.value,
                        label: item.label,
                    });

                    selectedReviewersData[item.value] = {
                        can_assess_stage1: item.can_assess_stage1,
                        can_assess_stage2: item.can_assess_stage2,
                        can_assess_stage3: item.can_assess_stage3,
                    };
                });

                return {
                    selectedReviewers,
                    selectedReviewersData,
                    hasAwardingProposal: data.has_awarding_proposal,
                    savingsAutomaticallyCalculated: data.savings_automatically_calculated,
                    data: {
                        savings_amount: floatToCommaDecimal(data.savings_amount),
                        savings_percentage: floatToCommaDecimal(data.savings_percentage),
                    },
                };
            });
    }

    onReviewersChange(selectedReviewers) {
        this.setState({selectedReviewers});
    }

    saveReviewers() {
        const {selectedReviewers, selectedReviewersData} = this.state;

        const formData = new FormData();

        selectedReviewers.forEach((item, index) => {
            const data = selectedReviewersData.hasOwnProperty(item.value)
                ? selectedReviewersData[item.value]
                : null;

            let canAssessBids = false;
            let canAssessWinner = false;
            let canAssessStage1 = false;
            let canAssessStage2 = false;
            let canAssessStage3 = false;

            if (data) {
                canAssessBids = (data.can_assess_bids === true);
                canAssessWinner = (data.can_assess_winner === true);
                canAssessStage1 = (data.can_assess_stage1 === true);
                canAssessStage2 = (data.can_assess_stage2 === true);
                canAssessStage3 = (data.can_assess_stage3 === true);
            }

            formData.append(`assessors[${index}][user_id]`, item.value);
            formData.append(`assessors[${index}][can_assess_bids]`, canAssessBids + '');
            formData.append(`assessors[${index}][can_assess_winner]`, canAssessWinner + '');
            formData.append(`assessors[${index}][can_assess_stage1]`, canAssessStage1 + '');
            formData.append(`assessors[${index}][can_assess_stage2]`, canAssessStage2 + '');
            formData.append(`assessors[${index}][can_assess_stage3]`, canAssessStage3 + '');
        });

        const file = this.awardingProposalInputRef.current.files[0];

        if (file) {
            formData.append('awarding_proposal', file);
        }

        let savingsAmount = commaDecimalToFloat(this.state.data.savings_amount);
        let savingsPercentage = commaDecimalToFloat(this.state.data.savings_percentage);

        formData.append('savings_amount', isNullOrUndefined(savingsAmount) ? '' : savingsAmount);
        formData.append('savings_percentage', isNullOrUndefined(savingsPercentage) ? '' : savingsPercentage);

        this.setState({result: null, loading: true}, () => {
            axios
                .post(
                    '/competitions/assessors/' + this.props.competitionId,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(() => this.fetchData())
                .then((data) => {
                    const {
                        selectedReviewers,
                        selectedReviewersData,
                        hasAwardingProposal,
                        savingsAutomaticallyCalculated,
                        data: formData,
                    } = data;

                    this.setState({
                        result: {
                            success: true,
                            message: window.__js_bid_reviews.competition_reviewers_set,
                        },
                        loading: false,
                        selectedReviewers,
                        selectedReviewersData,
                        hasAwardingProposal,
                        savingsAutomaticallyCalculated,
                        data: formData,
                    });
                })
                .catch(() => {
                    this.setState({
                        result: {
                            success: false,
                            message: window.__js_general.error_occurred_try_later,
                        },
                        loading: false,
                    });
                });
        });
    }

    onSaveButtonClick(e) {
        e.preventDefault();
        this.saveReviewers();
    }

    onPermissionChange(id, fieldName, checked) {
        const selectedReviewersData = cloneDeep(this.state.selectedReviewersData);

        if (selectedReviewersData.hasOwnProperty(id)) {
            selectedReviewersData[id][fieldName] = checked;
        } else {
            selectedReviewersData[id] = {
                [fieldName]: checked,
            };
        }

        this.setState({selectedReviewersData});
    }

    onChange(key, value) {
        const decimalFields = [
            'savings_amount',
            'savings_percentage',
        ];

        if (decimalFields.indexOf(key) !== -1) {
            value = Utils.handleDecimals(value);
        }

        const newData = cloneDeep(this.state.data);
        newData[key] = value;
        this.setState({data: newData});
    }

    render() {
        if (!this.props.isEditable) {
            return (
                <div>
                    <div className="form-group">
                        <label htmlFor="savings_amount">{window.__js_bid_reviews.savings_amount}</label>
                        <p className="form-control-static">{this.state.data.savings_amount}</p>
                    </div>

                    <div className="form-group">
                        <label htmlFor="savings_amount">{window.__js_bid_reviews.savings_percentage}</label>
                        <p className="form-control-static">{this.state.data.savings_percentage}</p>
                    </div>

                    <hr/>

                    {
                        this.state.hasAwardingProposal
                            ? <div>
                                <a href={`/competitions/download-awarding-proposal/${this.props.competitionId}`}
                                   target="_blank">
                                    <i className="fa fa-fw fa-download"></i> {window.__js_general.download} {window.__js_bid_reviews.awarding_proposal}
                                </a>
                                <hr/>
                            </div>
                            : null
                    }

                    <ReviewersTable
                        isReadonly={true}
                        reviewers={this.state.selectedReviewers}
                        data={this.state.selectedReviewersData}
                    />
                </div>
            );
        }

        return (
            <form className="form-horizontal">
                <div className="form-group">
                    <label htmlFor="reviewer_ids" className="control-label">
                        {window.__js_bid_reviews.select_reviewers_title}:
                    </label>
                    <Select name="reviewer_ids[]"
                            id="reviewer_ids"
                            multi={true}
                            placeholder={window.__js_bid_reviews.select_reviewers}
                            value={this.state.selectedReviewers}
                            options={this.state.reviewers}
                            onChange={this.onReviewersChange}/>
                </div>

                {
                    this.state.selectedReviewers.length === 0
                        ? null
                        : <ReviewersTable
                            reviewers={this.state.selectedReviewers}
                            data={this.state.selectedReviewersData}
                            onCheckboxChecked={this.onPermissionChange}
                        />
                }

                <div className="form-group">
                    <label htmlFor="awarding_proposal" className="control-label">
                        {window.__js_bid_reviews.awarding_proposal}:
                    </label>
                    <input
                        type="file"
                        className="form-control"
                        name="awarding_proposal"
                        id="awarding_proposal"
                        ref={this.awardingProposalInputRef}
                    />

                    {
                        this.state.hasAwardingProposal
                            ? <a href={`/competitions/download-awarding-proposal/${this.props.competitionId}`}
                                 target="_blank">
                                <i className="fa fa-fw fa-download"></i> {window.__js_general.download} {window.__js_bid_reviews.awarding_proposal}
                            </a>
                            : null
                    }
                </div>

                <hr/>

                <div className="form-group">
                    <label htmlFor="savings_amount">{window.__js_bid_reviews.savings_amount}</label>
                    <input type="text"
                           name="savings_amount"
                           id="savings_amount"
                           className="form-control"
                           value={this.state.data.savings_amount || ''}
                           onChange={(e) => this.onChange('savings_amount', e.target.value)}/>
                    <span className="help-block">
                        {window.__js_bid_reviews.comma_helper}
                    </span>
                </div>

                <div className="form-group">
                    <label htmlFor="savings_amount">{window.__js_bid_reviews.savings_percentage}</label>
                    <input type="text"
                           name="savings_percentage"
                           id="savings_percentage"
                           className="form-control"
                           value={this.state.data.savings_percentage || ''}
                           onChange={(e) => this.onChange('savings_percentage', e.target.value)}/>
                    <span className="help-block">
                        {window.__js_bid_reviews.comma_helper}
                    </span>
                </div>

                <br/>

                {
                    this.state.savingsAutomaticallyCalculated
                        ? <div>
                            <div className="alert alert-warning">
                                {window.__js_bid_reviews.savings_automatically_calculated}
                            </div>
                            <br/>
                        </div>
                        : null
                }

                <div className="form-group">
                    <button type="submit" className="btn btn-default" disabled={this.state.loading}
                            onClick={this.onSaveButtonClick}>
                        <span className="fa fa-save"></span> {window.__js_general.save}
                    </button>
                </div>

                <ResultMessage result={this.state.result}/>
            </form>
        );
    }
}

const element = document.getElementById('separate-bid-reviews-component');

if (element) {
    const competitionId = element.getAttribute('data-competition-id');
    const isEditable = (element.getAttribute('data-is-editable') === '1');

    ReactDOM.render(
        <SeparateBidReviewsComponent
            competitionId={competitionId}
            isEditable={isEditable}
        />,
        element
    );
}